const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店共度8小时全程被拍', views: '128.6万', tag: '娱乐圈', hot: true },
  { rank: 2, title: '知名女星前夫实锤爆料：婚姻内出轨证据完整视频流出', views: '96.3万', tag: '明星八卦', hot: true },
  { rank: 3, title: '某综艺节目后台爆发激烈冲突，两位导师当众大打出手', views: '87.1万', tag: '综艺', hot: true },
  { rank: 4, title: '娱乐圈新一轮税务风波，多位一线艺人被相关部门约谈', views: '74.5万', tag: '娱乐圈', hot: false },
  { rank: 5, title: '千万粉丝网红直播间翻车，卖假货遭打假人当场揭穿', views: '68.2万', tag: '网红圈', hot: false },
  { rank: 6, title: '知名导演潜规则新人演员，秘密录音曝光引发行业震动', views: '59.8万', tag: '影视圈', hot: false },
  { rank: 7, title: '某选秀节目票数造假完整证据链曝光，节目组连夜回应', views: '52.4万', tag: '综艺', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-fire-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热度榜单</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">实时更新 · 黑料在线观看热度最高的爆料内容</p>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#media"
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-md font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">{item.tag}</span>
                  {item.hot && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">HOT</span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-500 flex-shrink-0">
                <i className="ri-eye-line"></i>
                <span className="whitespace-nowrap">{item.views}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}